import React from 'react';
import { Redirect } from 'react-router';
import { FormView } from './FormView';

export default function FormViewJoinAsAlysei(props) {
  const currentSearch = props?.location?.search || '';
  const searchParams = new URLSearchParams(currentSearch);

  if (!searchParams.get('join')) {
    searchParams.set('join', 'alysei');
    const nextSearch = searchParams.toString();

    return (
      <Redirect
        to={{
          pathname: props?.location?.pathname || props?.match?.url || '/',
          search: nextSearch ? `?${nextSearch}` : '',
          hash: props?.location?.hash || '',
        }}
      />
    );
  }

  const mergedProps = {
    ...props,
    match: {
      ...props.match,
      params: { ...props.match?.params, role: 'italian-food-beverage-producers' },
    },
  };
  return <FormView {...mergedProps} />;
}
